import { render, staticRenderFns } from "./catalogueIntroduction.vue?vue&type=template&id=8c1d4636&"
import script from "./catalogueIntroduction.vue?vue&type=script&lang=js&"
export * from "./catalogueIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./catalogueIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports